export enum PAYMENT_TYPE {
  UPDATE_PAYMENT_METHOD = 'update_payment_method',
  CONTENT = 1,
  SUBSCRIBE = 2,
}
